import { CustomBillingField } from '../../common/models'
import { http } from './http'

export const getAllCustomBillingFields = () =>
  http.get<CustomBillingField[]>('/operations/festivals/billing-custom-fields')

export const getCustomBillingField = (id: string) =>
  http.get<CustomBillingField>(
    `/operations/festivals/billing-custom-fields/${id}`,
  )

export const updateCustomBillingField = (data: CustomBillingField) =>
  http.put<CustomBillingField>(
    '/operations/festivals/billing-custom-fields',
    data,
  )

export const deleteCustomBillingField = (ids: string[]) =>
  http.delete<void>('/operations/festivals/billing-custom-fields', {
    data: { ids },
  })
